import { EquipmentTrainerToggleGroup } from '../../models/equipmentToggleOptions';
import { Profession } from '../../models/profession';
import { Race } from '../../models/race';
import data from './data.json';

const races = data.races as unknown as Race[];
const professions = data.professions as unknown as Profession[];
const toggleOptions = data.toggleOptions as unknown as EquipmentTrainerToggleGroup[];

races.forEach((v, i) => v.idNum = i + 1);
professions.forEach((v, i) => v.idNum = i + 1);

class EquipmentTrainerData {
  
  getRaces(): Race[] {
    return races;
  }

  getProfessions() {
    return professions;
  }

  getToggleOptions() {
    return toggleOptions;
  }
}


export const equipmentTrainerData = new EquipmentTrainerData();